<template>
  <div>
    <header class="notification level is-mobile is-site-coler">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title" v-on:click="go_To_Home">Iventer</h1>
        </div>
      </div>
      <nav class="level-right">
        <div class="level-item">
          <button class="button" type="button" v-on:click="logout" v-if="user">
            <b-icon pack="fas" icon="sign-out-alt"></b-icon>
          </button>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header",
  data: function() {
    return {};
  },
  methods: {
    logout: function() {
      this.$store.dispatch("auth/remove_User");
    },
    go_To_Home: function() {
      this.$router.push({
        name: "Ivent_Home"
      });
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/get"];
    }
  }
};
</script>
